import { createSelector } from 'reselect'
import combineTimestamps from '../utility/combineTimestamps'

const getTimestamps = state => {
  return state.timestamp.timestamps
}

export const getCombinedTimestamps = createSelector(
  [getTimestamps],
  timestamps => {
    try {
      return combineTimestamps(timestamps)
    } catch (error) {
      return []
    }
  }
)



// WEBPACK FOOTER //
// ./src/selectors/combinedTimestampsSelector.js